export enum AccessType {
  ADMIN = 'ADMIN',
  BRAND = 'BRAND',
  CONSULTANT = 'CONSULTANT',
  FACTORY = 'FACTORY'
}

export enum AccessRole {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export enum UserType {
  Factory = 'FACTORY',
  Brand = 'BRAND',
  Consultant = 'CONSULTANT',
  GroupOfFactory = 'GROUP_OF_FACTORY',
  Association = 'ASSOCIATION',
  RtisAdmin = 'RTIS_ADMIN'
}

export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER',
  SuperUser = 'SUPER_USER'
}
